import { CATEGORY } from "./actions";
import RecipeService from "../services/recipe-service";

const MUTATION = {
  SET_CATEGORIES: "SET_CATEGORIES"
};

export default {
  namespaced: true,
  state: {
    categories: null
  },
  mutations: {
    [MUTATION.SET_CATEGORIES](state, categories) {
      state.categories = categories;
    },
  },
  actions: {
    async [CATEGORY.GET_ALL]({ commit }) {
      const cats = await RecipeService.findAllCategories();
      commit(MUTATION.SET_CATEGORIES, cats);
    }
  }
};
